import {
	defaultShouldDehydrateQuery,
	keepPreviousData,
	QueryClient,
} from "@tanstack/react-query";

export function createQueryClient() {
	return new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 60 * 1000,
				retry: false,
				// Keep showing previous data while fetching new results.
				// Prevents UI flicker when filters/search params change.
				placeholderData: keepPreviousData,
			},
			dehydrate: {
				// Also dehydrate still-pending queries. This is what makes the
				// ensureQueryData + useSuspenseQuery + AsyncBoundary SSR flow
				// hydrate without a client-side refetch.
				shouldDehydrateQuery: (query) =>
					defaultShouldDehydrateQuery(query) ||
					query.state.status === "pending",
			},
		},
	});
}
